import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import type SessionContextService from 'tio-employee/services/session-context';

/**
 * Beta dashboard header — adds the missing H1 heading and a welcome message.
 * Only renders when beta experience is enabled via Profile toggle.
 *
 * This is the first beta-graduated feature: fixing the accessibility issue
 * where the dashboard had 0 H1 headings (found by UX audit).
 */

interface S {
  Args: {
    person?: { firstName?: string };
  };
}

export default class BetaDashboardHeader extends Component<S> {
  @service declare sessionContext: SessionContextService;

  get firstName(): string {
    return this.args.person?.firstName || this.sessionContext.user?.person?.firstName || '';
  }

  get greeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  }

  <template>
    <div class="px-1 pb-4">
      <h1 class="text-2xl font-semibold text-gray-900">
        {{t "dashboard_beta.heading"}}
      </h1>
      {{#if this.firstName}}
        <p class="text-sm text-gray-500 mt-1">
          {{this.greeting}},
          {{this.firstName}}
        </p>
      {{/if}}
    </div>
  </template>
}
